import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    wishlistItems: [],
    compareItems: [],
    cartItems: [],
    isHydrated: false,
};

export const ecommerce = createSlice({
    name: 'ecommerce',
    initialState,
    reducers: {
        reset: () => initialState,
        showMessage: (state, action) => {
            return { ...state };
        },
        changeCartItems: (state, action) => {
            if (typeof window !== 'undefined') {
                localStorage.setItem('cartItems', JSON.stringify(action.payload));
            }
            return { ...state, cartItems: action.payload };
        },
        changeWishlistItems: (state, action) => {
            return { ...state, wishlistItems: action.payload };
        },
        changeCompareItems: (state, action) => {
            return { ...state, compareItems: action.payload };
        },
        setHydrated: (state) => {
            return { ...state, isHydrated: true };
        },
        syncCartFromStorage: (state, action) => {
            return { ...state, cartItems: action.payload };
        },
    },
});

export const {
    reset,
    showMessage,
    changeCartItems,
    changeWishlistItems,
    changeCompareItems,
    setHydrated,
    syncCartFromStorage,
} = ecommerce.actions;

export default ecommerce.reducer;